const conditions = () => {
  return [{ assetClass: { $ne: '' } }, { assetClass: 'object.asset-class.options.hotel' }]
}

export default conditions
